<template>
  <button class="plus-icon noborder bg-transparent pointer"
          @click="$emit('click')">
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.5 1V22M1 11.5H22" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
</template>

<script>
  export default {
    name: 'PlusIcon',
    props: {
      color: {
        type: String,
        cy: String,
        default: '#C78117'
      }
    }
  }
</script>

<style lang="less">
  .plus-icon {
    @media only screen and (min-width: 0) {
      transition: transform 0.1s ease-in-out;
      &:hover {
        transform: scale(1.1);
      }
    }
  }
</style>
